import { callFirebaseFunction, useFirebaseFunction } from '../../../../../../services/firebaseFunctions';

export type RipplingStatusFilter = 'ACTIVE' | 'ACTIVE_AND_TERMINATED';

export type RipplingConnectionStatus = {
  connected: boolean;
  statusFilter: RipplingStatusFilter;
};

export const useRipplingConnectionStatus = (orgId: string, refreshKey: number) => {
  return useFirebaseFunction<RipplingConnectionStatus>(
    'rippling_getConnectionStatus',
    { orgId },
    [orgId, refreshKey]
  );
};

export const disconnectRippling = (orgId: string) => {
  return callFirebaseFunction<{ success: true }>('rippling_disconnect', { orgId });
};

export const updateRipplingStatusFilter = (
  orgId: string,
  statusFilter: RipplingStatusFilter
) => {
  return callFirebaseFunction<{ success: true }>('rippling_updateStatusFilter', {
    orgId,
    statusFilter
  });
};


